import ComparePage from './CompareLayout';
import { CAYDA, ADV } from './caydaFacts';

const VsRuttl = () => (
  <ComparePage
    slug="ruttl"
    competitor="Ruttl"
    description="Ruttl alternative: Cayda runs on your real site instead of a copy, captures browser context with every note, and costs $6 per teammate instead of $18."
    hero="The Ruttl alternative that costs $6 a seat, not $18."
    intro="Ruttl loads a copy of your page inside Ruttl and bills $18 for every user. Cayda runs on your own domain through one script tag, records the browser, OS and viewport behind every note, and bills a base fee plus $5 to $6 per teammate. Five people with Jira: $38 versus $90."
    verdict={[
      { label: 'Starting price', cayda: '$9/mo', other: '$18/user/mo' },
      { label: 'Per teammate', cayda: '$6', other: '$18' },
      { label: 'Runs on', cayda: 'Your domain', other: 'A copy inside Ruttl' },
      { label: 'Free plan', cayda: '50 notes per site', other: '10 comments' },
    ]}
    advantages={[
      { ...ADV.pricing, body: 'A base fee covers you; each accepted teammate is $5 to $6 instead of $18. Two people pay $14 on Pro. Ten people with Jira, Asana and Linear pay $68, not $180. The gap widens with every person you add.' },
      { ...ADV.realSite, body: 'One script tag on your own domain. Your team reviews the page that actually shipped, logged in as themselves, so authenticated pages, single page apps and staging environments work without a browser extension.' },
      { ...ADV.capture, body: 'Every note pins to the element and records a screenshot, page URL, browser, OS and viewport, so a developer knows exactly what the reviewer saw. Screen recording on the Team plan.' },
      { ...ADV.dashboard, body: 'Kanban and list views, filters by status, priority, assignee and note type, bulk actions, threaded comments, an activity feed and CSV export on Pro. Slack on Pro; Jira, Asana and Linear on Team.' },
    ]}
    cost={{
      note: 'Cayda: annual billing, per month. Ruttl: the monthly per-user price shown on ruttl.com/pricing, September 2026 (no annual figure displayed).',
      scenarios: [
        { label: 'Solo freelancer', detail: 'unlimited sites', cayda: 9, other: 18, caydaPlan: 'Pro, owner covered', otherPlan: 'Pro, 1 user' },
        { label: 'Team of five, Jira', detail: 'plus Asana, Linear, screen recording, guests', cayda: CAYDA.teamPrice(4), other: 90, caydaPlan: 'Team + 4 members', otherPlan: 'Pro, 5 users' },
        { label: 'Team of ten, Jira', detail: 'per person: $6 vs $18', cayda: CAYDA.teamPrice(9), other: 180, caydaPlan: 'Team + 9 members', otherPlan: 'Pro, 10 users' },
      ],
    }}
    diagram="proxy"
    features={{
      note: 'Cayda plan names in the Cayda column. Ruttl details from ruttl.com/pricing and its support pages, September 2026.',
      rows: [
        ['Free plan', CAYDA.free, '1 project · 5 pages · 10 comments'],
        ['Paid plan', CAYDA.pro, '$18 per user'],
        ['Jira, Asana, Slack', 'Pro (Slack) · Team (Jira, Asana)', 'All plans'],
        ['Linear', 'Team', 'Not listed'],
        ['Runs on your live domain', true, false],
        ['Pages behind login, web apps', true, 'Chrome extension'],
        ['Visible to site visitors', 'Never', 'Never (separate link)'],
        ['Auto screenshot, browser, OS, viewport', true, 'Screenshot'],
        ['Screen recording', 'Team', 'Video comments'],
        ['Kanban + list dashboard, bulk actions', true, 'Comment list'],
        ['Client / guest reviewers', 'Team, no member fee', 'Unlimited'],
        ['CSV export', 'Pro', 'Not listed'],
        ['WordPress plugin, Shopify app', true, 'Not listed'],
      ],
    }}
    approach={[
      'Ruttl is a design review tool. It loads your page inside Ruttl, and its distinctive feature is live editing: reviewers can change text, fonts, spacing and images on that copy to show a developer what they mean. Password protected pages need its Chrome extension, pricing is $18 per user per month on the Pro plan, and the free plan stops at one project, five pages and ten comments.',
      'Cayda is a feedback tool for the live site. The review happens on your domain, every note carries the technical context a developer needs, and pricing is a base fee plus $5 to $6 per teammate.',
    ]}
    bottomLine={[
      'If your team is reviewing a real application or a set of client sites and wants notes that arrive with browser context and land in Slack, Jira, Asana or Linear, Cayda does it on the site itself for a third of the per-seat price. Start free on two sites.',
    ]}
  />
);

export default VsRuttl;
